import { deepCopy } from "@perxis-auto/shared/lib/lib/copy";
import { instanceOfReference } from "@perxis-auto/shared/lib/lib/instanceOf";
import { COLLECTION_IDS } from "../../../../shared/config/collections.js";
import "history";
import { PerxisService } from "../../../../shared/services/perxis/index.js";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import { selectFilterGridItems } from "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSlice } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import { getExtendedItems } from "../../../../shared/store/reference/lib/getExtendedItems.js";
import "@perxis-auto/shared";
import "../../../../shared/store/reference/model/index.js";
import { ConstructorWidgetEnum } from "../../../../shared/types/constructor/widget.js";
import { FilterLocationEnum } from "../../types/values.js";
import { createRawFilterValuesItem } from "./create/createRawFilterValuesItem.js";
const fetchFilterValuesWithExtraValues = async (queryApi, rawFilterValuesItem) => {
  const state = queryApi.getState();
  const config = selectSlice(state);
  const filterGridItems = selectFilterGridItems(state);
  const { itemsClient } = PerxisService.getInstance();
  const rawFilterValuesWithExtraValuesItem = deepCopy(rawFilterValuesItem);
  const { data } = rawFilterValuesWithExtraValuesItem;
  const promises = [];
  for (const [key, values] of Object.entries(data)) {
    const filterGridItem = filterGridItems.find((item) => item.key === key);
    if (!filterGridItem) {
      continue;
    }
    switch (filterGridItem.type) {
      case ConstructorWidgetEnum.FilterLocation: {
        if (!Array.isArray(values) || values.length <= 1) {
          break;
        }
        if (!instanceOfReference(values[0])) {
          break;
        }
        const filterLocationValues = values;
        const clusters = filterLocationValues.reduce((acc, value) => {
          if (instanceOfReference(value.cluster)) {
            return [...acc, value.cluster];
          }
          return acc;
        }, []);
        if (!clusters.length) {
          break;
        }
        const locationPromise = itemsClient.findPublished({
          spaceId: config.spaceId,
          envId: config.envId,
          collectionId: clusters[0].collection_id,
          filter: {
            id: clusters.map((c) => c.id)
          }
        }).then(({ items }) => {
          const filterLocationClusterValues = items.map(
            (item) => {
              return {
                id: item.id,
                name: item.data.name,
                displayName: item.data.name,
                position: item.data.position,
                available: true,
                disabled: false,
                collection_id: item.collectionId,
                type: FilterLocationEnum.Cluster
              };
            }
          );
          filterLocationValues.unshift(...filterLocationClusterValues);
        });
        promises.push(locationPromise);
        break;
      }
      case ConstructorWidgetEnum.FilterOptions: {
        const filterPackageValues = (data == null ? void 0 : data.package) || [];
        const filterPackageOptionsValues = values;
        const packageOptionsParameters = {
          spaceId: config.spaceId,
          envId: config.envId,
          collectionId: COLLECTION_IDS.vehiclesPackages,
          filter: {
            q: [`id in ["${filterPackageValues.map((item) => item.id).join(`", "`)}"]`]
          },
          options: {
            fields: {
              [filterGridItem.key]: "distinct(options)"
            }
          }
        };
        const packageOptionsPromise = itemsClient.aggregatePublished(packageOptionsParameters).then(({ result }) => {
          const rawFilterValuesForPackageOptions = createRawFilterValuesItem(result || {}, packageOptionsParameters);
          return getExtendedItems(queryApi, [
            rawFilterValuesForPackageOptions
          ]);
        }).then(([extRawFilterValuesForPackageOptions]) => {
          var _a;
          const packageOptions = ((_a = extRawFilterValuesForPackageOptions.data) == null ? void 0 : _a[filterGridItem.key]) || [];
          const popularPackageOptions = packageOptions.filter((option) => !!option.isPopular);
          const rawFilterValuesForPackageOptionGroups = createRawFilterValuesItem(
            {
              group: popularPackageOptions.map((option) => option.group)
            },
            packageOptionsParameters
          );
          return getExtendedItems(queryApi, [
            rawFilterValuesForPackageOptionGroups
          ]).then(([extRawFilterValuesForPackageOptionGroups]) => {
            var _a2;
            const packageOptionGroups = ((_a2 = extRawFilterValuesForPackageOptionGroups.data) == null ? void 0 : _a2.group) || [];
            return popularPackageOptions.map(
              (option) => ({
                ...option,
                group: {
                  ...option.group,
                  ...packageOptionGroups.find((group) => {
                    return group.id === option.group.id;
                  })
                },
                packageIds: filterPackageValues.filter((p) => {
                  const options = p.options || [];
                  return options.find((o) => o.id === option.id);
                }).map((p) => p.id)
              })
            );
          });
        }).then((popularPackageOptionsWithExtOptionGroupData) => {
          filterPackageOptionsValues.push(...popularPackageOptionsWithExtOptionGroupData);
        });
        promises.push(packageOptionsPromise);
        break;
      }
    }
  }
  await Promise.all(promises);
  return rawFilterValuesWithExtraValuesItem;
};
export {
  fetchFilterValuesWithExtraValues
};
